import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex);

export default new Vuex.Store({
    state:{
        click:'',
        pathName: "1",
        currDbSource: {},
        currJobData: {},
        DbSource: [],
        information:'',
        shopsSearchValue:'',
        categorySearchValue:'',
        userdisposh:'',
        total_unread: 0,
    },
    mutations:{
        changeclick(state,x){
            state.click = x
        },
        changeuserdisposh(state,x){
          state.userdisposh = x
        },
        // 保存当前菜单栏的路径
        savePath(state,pathName){
            state.pathName = pathName;
        },
        // 保存当前点击的数据源
        saveCurrDbSource(state,currDbSource){
            state.currDbSource = currDbSource;
        },
        // 保存当前点击的元数据
        saveCurrJobData(state,currJobData){
            state.currJobData = currJobData;
        },
        // 保存所有数据源
        saveDbSource(state,DbSource){  //购买数量
            state.DbSource = DbSource;
        },
        information_event(state,information){ //个人信息
            state.information = information
        },
        shopsSearchValue(state,shopsSearchValue){
            state.shopsSearchValue = shopsSearchValue
        },
        categorySearchValue(state,categorySearchValue){
            state.categorySearchValue = categorySearchValue
        },
        set_total_unread(state,total_unread){
            state.total_unread = total_unread
        }
    }
})